import React ,{useState} from "react";

const Modal = (props) => { 
  const handleDeleteAll = () => {
    if(Number(document.getElementById("captchaEntered").value)===props.captcha){
      props.requiredFunc()
    }else{
      props.showAlert('danger',"Error", "Captcha Invalid")
      document.getElementById('captchaEntered').value = "";
    }
  };
  return (
    <>
      <div
        data-bs-theme={`${props.theme==="dark"?"dark":""}`}
        className="modal fade"
        id={props.modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className={`modal-dialog ${props.theme==="dark"?"text-light":""} `}>
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                {props.title}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">{props.message}</div>
            <div className="d-flex justify-content-center mb-3">
            <input type="text" id="captcha" style={{width:"20%", textAlign:"center",margin:"0 5px"}} disabled={true} value={props.captcha}/>
            <input type="text" id="captchaEntered" style={{width:"60%", textAlign:"center",margin:"0 5px"}} placeholder="Enter Captcha"/>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={handleDeleteAll}  data-bs-dismiss="modal">
                Delete All
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
